import {
    activateLocation,
    closeDialog,
    collectLocation,
    exportXml,
    openLocationDashboard,
    scheduleCollect,
    submitForm,
} from '../../actions';
import { ActionsSection, RowItemType, SectionType, UIElementType } from '../../models';
import { ForesiteXDSectionIds } from './base-config-models';
import { DialogActionsFieldId } from '../common.models';
import { ButtonDisableIdentifier } from '../../models/validator-identifier';
import { ForesiteXDLocationCardState } from './models';

export const dialogActions = (state: ForesiteXDLocationCardState): ActionsSection => {
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[0] : null;
    const isEditMode = !!details;

    return {
        info: {
            id: ForesiteXDSectionIds.DialogActions,
            title: '',
            type: SectionType.Actions,
            displayTitle: false,
            expandable: false,
            expanded: true,
            panelClass: 'dialog-actions-container',
        },
        rows: [
            // Left side buttons row
            {
                info: {
                    id: 'pre-edit-controls-row',
                    panelClass: 'pre-edit-controls',
                },
                items: [
                    {
                        id: DialogActionsFieldId.ActivateButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'activateButton',
                        imgSrc: '/assets/images/active_disable.png',
                        imgHeight: 24,
                        imgWidth: 24,
                        imgClass: 'img-icon-24',
                        enabledImgSrc: '/assets/images/active.png',
                        enabledImgClass: 'img-icon-24',
                        tooltip: 'COMMON.ACTIVATE_BUTTON',
                        panelClass: '',
                        disabledSelector: ButtonDisableIdentifier.activateDisabled,
                        events: {
                            onClick: () => [activateLocation()],
                        },
                    },
                    {
                        id: DialogActionsFieldId.LocationDashboardButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        visible: isEditMode && state.fromHomeDashboard,
                        name: 'locationDashboardButton',
                        tooltip: 'HOME.MAP.LOCATION_DASHBOARD_TOOLTIP',
                        iconName: 'show_chart',
                        panelClass: 'auto-margin',
                        events: {
                            onClick: () => [openLocationDashboard()],
                        },
                    },
                    {
                        id: DialogActionsFieldId.CollectButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'collectButton',
                        visible: isEditMode,
                        tooltip: 'HOME.COLLECTION_WIDGET.COLLECT_BUTTON',
                        iconName: 'system_update_alt',
                        panelClass: 'auto-margin',
                        events: {
                            onClick: () => [collectLocation()],
                        },
                    },
                    {
                        id: DialogActionsFieldId.ScheduleCollect,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'collectButton',
                        visible: isEditMode,
                        tooltip: 'HOME.MAP.SCHEDULR_COLLECTION_TOOLTIP',
                        iconName: 'update',
                        panelClass: 'auto-margin',
                        events: {
                            onClick: () => [scheduleCollect()],
                        },
                    },
                    {
                        id: DialogActionsFieldId.ExportBUtton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'exportButton',
                        visible: isEditMode && !state.locationCardData?.isFromNotificationDash,
                        tooltip: 'COMMON.EXPORT_TEXT',
                        iconName: 'get_app',
                        panelClass: 'auto-margin',
                        events: {
                            onClick: () => [exportXml()],
                        },
                    },
                ],
            },
            // Cancel button row
            {
                info: {
                    id: 'cancel-button-row',
                    panelClass: '',
                },
                items: [
                    {
                        id: DialogActionsFieldId.CancelButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'cancelButton',
                        label: 'COMMON.CANCEL',
                        panelClass: 'mat-button',
                        events: {
                            onClick: () => [closeDialog()],
                        },
                    },
                    {
                        id: DialogActionsFieldId.SaveButton,
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'saveButton',
                        label: 'COMMON.SAVE_CLOSE_BUTTON',
                        disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
                        panelClass: 'mat-button pr-0',
                        events: {
                            onClick: () => [submitForm({ shouldClose: true, isActivationRequired: false })],
                        },
                    },
                    {
                        id: 'verticalDivider',
                        type: RowItemType.UI,
                        uiType: UIElementType.Divider,
                        name: 'verticalDivider',
                        dividerStyle: 'solid',
                        dividerThickness: 1,
                        disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
                        dividerColor: '#e0e0e0',
                        panelClass: 'divider-vertical',
                    },
                    {
                        id: 'moreOptionsMenu',
                        type: RowItemType.UI,
                        uiType: UIElementType.Menu,
                        name: 'moreOptionsMenu',
                        iconName: 'arrow_drop_down',
                        disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
                        panelClass: 'pl-2 menu-button',
                        menuConfig: {
                            label: '',
                            items: [
                                {
                                    id: 'saveMenuItem',
                                    type: RowItemType.UI,
                                    uiType: UIElementType.Button,
                                    name: 'saveButton',
                                    label: 'COMMON.SAVE_BUTTON',
                                    disabledSelector: ButtonDisableIdentifier.invalidOrPristine,
                                    panelClass: 'mat-button',
                                    events: {
                                        onClick: () => [submitForm({ shouldClose: false, isActivationRequired: false })],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    };
};
